import React, {useEffect, useState} from 'react';
import './mobile-number-component-style.scss';
import OnboardInput from "../onboard-input/OnboardInput";
import {useTranslation} from "react-i18next";
import {getAreaCodeLookup} from "../../../util/LanguageContentManager";
import OnboardSelect from "../onboard-select-component/OnboardSelect";

const MobileNumberComponent = (props) => {
    const {t, i18n} = useTranslation();
    const {onChangeAreaCode, onChangeNumber, errorAreaCode, errorNumber} = props;

    const [areaCode, setAreaCode] = useState(null);
    const [number, setNumber] = useState(null);

    useEffect(() => {
        if (onChangeAreaCode !== undefined) {
            onChangeAreaCode(areaCode)
        }
    }, [areaCode]);

    useEffect(() => {
        if (onChangeNumber !== undefined) {
            onChangeNumber(number)
        }
    }, [number]);

    return (
        <div className="mobile-number-component-root">
            <div className="mobile-number-component-area">
                <OnboardSelect placeholder={t('register.area_code')} options={getAreaCodeLookup(i18n)}
                               value={areaCode} error={errorAreaCode} phoneType
                               onChange={(e) => setAreaCode(e)}/>
            </div>
            <div className="mobile-number-component-sec">
                <OnboardInput placeholder={t('register.mobile_number')} onChange={(e) => setNumber(e)}
                              type="text" error={errorNumber}
                              mask={{mask: "9{1,15}"}}
                              value={number}/>
            </div>
        </div>
    )
};

export default MobileNumberComponent;



